import React, { useState, useRef } from 'react';
import ChangePassword from './ChangePassword';

const API_URL = 'https://jxbk.jingchaowan.dpdns.org';

const Sidebar = ({ operators, selectedOperator, onOperatorChange, user, onLogout }) => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState('全部');
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [allCompanyStaff, setAllCompanyStaff] = useState([]);
  const [showStaffModal, setShowStaffStaffModal] = useState(false);
  const fileInputRef = useRef(null);

  const departments = ['全部', ...new Set(operators.map(op => op.department || '运营部'))];
  
  const filteredOperators = selectedDepartment === '全部'
    ? operators
    : operators.filter(op => (op.department || '运营部') === selectedDepartment);

  // 当部门切换时，如果当前选中人员不在新列表中，重置选择
  React.useEffect(() => {
    if (filteredOperators.length > 0) {
      // 检查当前选中的人员是否在过滤后的列表中
      const isSelectedInList = selectedOperator && filteredOperators.some(op => op.operator_name === selectedOperator.operator_name);
      
      // 如果不在列表中（比如切换了部门），或者当前没有选中任何人，则默认选中第一个
      if (!isSelectedInList) {
        onOperatorChange(filteredOperators[0].operator_name);
      }
    }
  }, [selectedDepartment, filteredOperators, selectedOperator, onOperatorChange]);

  const handleSync = async () => {
    setIsSyncing(true);
    alert('正在后台同步最新数据，请稍候...');
    try {
      const response = await fetch(`${API_URL}/update`, { method: 'POST' });
      if (!response.ok) {
        throw new Error(`同步请求失败: ${response.status}`);
      }
      const result = await response.json();
      alert(`同步成功！\n${result.message}`);
      
      localStorage.removeItem('performanceData');
      window.location.reload();

    } catch (error) {
      alert(`同步失败: ${error.message}`);
    } finally {
      setIsSyncing(false);
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleResetGroups = async () => {
    if (!window.confirm('警告：这将彻底清空所有门店的分组和人员分配信息！确定要重置吗？')) return;
    
    try {
      const response = await fetch(`${API_URL}/reset-groups`, { method: 'POST' });
      if (!response.ok) throw new Error('重置失败');
      alert('分组信息已重置！页面即将刷新。');
      localStorage.removeItem('performanceData');
      window.location.reload();
    } catch (error) {
      alert(error.message);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('请先选择一个文件！');
      return;
    }
    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch(`${API_URL}/update-groups`, {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();
      
      if (!response.ok) {
        let errorMsg = result.error || result.message || `HTTP ${response.status}`;
        if (result.debug) {
            errorMsg += `\n\n调试信息:\n列名: ${result.debug.columns || result.debug.sample_rows?.[0]}\n样本: ${JSON.stringify(result.debug.sample || result.debug.sample_rows?.[1])}`;
        }
        throw new Error(errorMsg);
      }
      
      alert(`分组更新成功！\n${result.message}`);
      // 上传成功后清除缓存并刷新，确保侧边栏名单更新
      localStorage.removeItem('performanceData');
      window.location.reload();
    } catch (error) {
      alert(`上传失败: ${error.message}`);
    } finally {
      setIsUploading(false);
      setSelectedFile(null);
    }
  };

  const fetchCompanyStaff = async () => {
    try {
      const response = await fetch(`${API_URL}/operators`);
      if (!response.ok) throw new Error('获取员工列表失败');
      const data = await response.json();
      // 硬过滤：移除李顺凤
      setAllCompanyStaff(data.filter(name => name !== '李顺凤'));
      setShowStaffStaffModal(true);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleDeletePerson = async (name) => {
    if (!window.confirm(`确定要彻底删除人员 "${name}" 吗？\n此操作将删除其所有 KPI 模板、历史考核记录和分组信息，且不可恢复！`)) return;

    try {
      const response = await fetch(`${API_URL}/person/${encodeURIComponent(name)}`, {
        method: 'DELETE'
      });
      const result = await response.json();

      if (!response.ok) throw new Error(result.error || '删除失败');

      alert(result.message);
      // 更新本地状态并刷新页面数据
      setAllCompanyStaff(prev => prev.filter(n => n !== name));
      localStorage.removeItem('performanceData');
      window.location.reload();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header" style={{ marginBottom: '20px' }}>
         <h2 style={{ marginBottom: '10px' }}>数据管理</h2>
         <div className="user-info" style={{ fontSize: '14px', color: '#666' }}>
             当前用户: <strong>{user?.username}</strong> ({user?.role === 'admin' ? '管理员' : user?.role === 'viewer' ? '只读账号' : '员工'})
         </div>
         <div className="user-actions" style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
             <button onClick={() => setShowChangePassword(true)} style={{ padding: '5px 10px', fontSize: '12px' }}>修改密码</button>
             <button onClick={onLogout} style={{ padding: '5px 10px', fontSize: '12px', backgroundColor: '#ff4d4f', color: 'white', border: 'none', borderRadius: '4px' }}>退出</button>
         </div>
      </div>

      {showChangePassword && (
          <ChangePassword username={user.username} onClose={() => setShowChangePassword(false)} />
      )}

      {showStaffModal && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-content" style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', maxWidth: '400px', width: '90%', maxHeight: '80vh', overflowY: 'auto' }}>
            <h3>公司当前所有员工 ({allCompanyStaff.length}人)</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', margin: '15px 0' }}>
              {allCompanyStaff.map(name => (
                <div key={name} style={{ padding: '5px', border: '1px solid #eee', borderRadius: '4px', textAlign: 'center', fontSize: '14px', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <span style={{ flex: 1 }}>{name}</span>
                  {user?.role === 'admin' && (
                    <button
                      onClick={() => handleDeletePerson(name)}
                      style={{ border: 'none', background: 'none', color: '#ff4d4f', cursor: 'pointer', padding: '0 5px', fontSize: '16px', fontWeight: 'bold' }}
                      title="删除该人员"
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
            </div>
            <button onClick={() => setShowStaffStaffModal(false)} style={{ width: '100%', padding: '10px', marginTop: '10px' }}>关闭</button>
          </div>
        </div>
      )}

      <div className="sidebar-section">
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="department-select">选择部门</label>
          <select
            id="department-select"
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            disabled={user?.role === 'yuangong'}
          >
            {departments.map(dept => (
              <option key={dept} value={dept}>{dept}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="operator-select">选择成员</label>
          <select
            id="operator-select"
            value={selectedOperator?.operator_name || ''}
            onChange={(e) => onOperatorChange(e.target.value)}
            disabled={user?.role === 'yuangong'}
          >
            <option value="" disabled>请选择人员</option>
            {filteredOperators.map((op) => (
              <option key={op.operator_name} value={op.operator_name}>
                {op.operator_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Portal 挂载点：用于从 MainContent 注入出勤天数配置 */}
      <div id="sidebar-working-days-portal"></div>

      {user?.role !== 'yuangong' && (
        <>
          <div className="sidebar-section">
            <h3>数据采集</h3>
            <button className="sync-button" onClick={handleSync} disabled={isSyncing}>
              {isSyncing ? '同步中...' : '立刻同步'}
            </button>
          </div>

          <div className="sidebar-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h3 style={{ margin: 0 }}>分组管理</h3>
              <button
                onClick={fetchCompanyStaff}
                style={{ fontSize: '12px', padding: '2px 8px', cursor: 'pointer', backgroundColor: '#f0f0f0', border: '1px solid #ccc', borderRadius: '4px' }}
              >
                查看当前员工
              </button>
            </div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept=".xlsx, .xls"
            />
            <button className="upload-button" onClick={handleUploadClick} disabled={isUploading}>
              选择文件
            </button>
            {selectedFile && <span className="file-name">{selectedFile.name}</span>}
            <button className="sync-button" onClick={handleUpload} disabled={isUploading || !selectedFile} style={{marginTop: '10px'}}>
              {isUploading ? '上传中...' : '上传分组'}
            </button>
            <button
              onClick={handleResetGroups}
              style={{ width: '100%', marginTop: '10px', padding: '8px', fontSize: '12px', color: '#ff4d4f', border: '1px solid #ff4d4f', backgroundColor: 'transparent', borderRadius: '4px', cursor: 'pointer' }}
            >
              强制重置分组数据
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
